module.exports = __webpack_public_path__ + "static/img/DaimlerCAC-Regular.f50770ce.svg";